import i18n from '../../locales/index'
/* eslint-disable */
import { genBasicStore } from '../vuex';
export default genBasicStore('keyboard_shortcut');